import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net";
import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";
import { useToast } from "@/components/Toast/useToast";
import Swal from "sweetalert2";

export default {
  name: "WorkflowServices",
  setup() {
    const { showSuccess, showError } = useToast();

    return {
      showSuccess,
      showError,
    };
  },
  data: () => ({
    services: [],
    checked_services: new Set(),
    loading: false,
    register_forms: [],
    workflows: [],
    assigned_workflows_map: {},
    safps_checks: {},
    add_decision_engine: {},
    workflow_project_services: {},
    project_name: "",
    SAFPS_SERVICES: ["RSA ID Verification", "ID Verification (Liveness check)"],
    DECISION_ENGINE_SERVICES: ["Credit Report Namibia"],
    SERVICES_WITH_RULES: [
      "Enterprise Anti Money Laundering",
      "Enterprise Credit Check",
      "ID Verification (Liveness check)",
      "Director Screening",
      "Anti Money Laundering",
      "OCR verification",
      "RSA ID Verification",
      "Online Bank Statements",
      "Manual Bank Statement Upload",
      "CIPC Plus Score",
      "Experian Credit Report (PDF)",
      "OCR Liveness Verification",
    ],
  }),
  computed: {
    project_id() {
      return this.$store.getters.get_project_id;
    },
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  methods: {
    get_services_in_project() {
      const TOKEN = localStorage.getItem("token");
      const GET_PROJECT_SERVICES_API = `${API_BASE_URL}/verify_api/workflow_management_api/project_services_api/${this.project_id}/${this.workflow_id}`;

      $.ajax({
        url: GET_PROJECT_SERVICES_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          this.loading = true;
        },
        success: (response) => {
          if (response.project_name) {
            this.project_name = this.capitalize_first_letter(
              response.project_name,
            );
          }

          // Initialize services with is_checked defaulting to false
          this.services = Array.isArray(response.all_services)
            ? response.all_services.map((service) => ({
                ...service,
                is_checked: false, // Default to false if not provided by the API
              }))
            : [];

          this.update_service_status();

          this.loading = false;
          this.$nextTick(() => {
            if ($.fn.dataTable.isDataTable("#workflow-service-table")) {
              $("#workflow-service-table").DataTable().destroy();
            }
            $("#workflow-service-table").DataTable({
              responsive: true,
            });
          });
        },
        error: (error) => {
          this.loading = false;
          let error_message = "Error Getting Service(s)";
          if (error.responseJSON) {
            const ERROR_RESPONSE = error.responseJSON;
            if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
              error_message = ERROR_RESPONSE.error;
            }
          }
          this.showError("Error", error_message);
        },
      });
    },

    capitalize_first_letter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    update_service_status() {
      const TOKEN = localStorage.getItem("token");
      const GET_CHECKED_SERVICE_STATUS_API = `${API_BASE_URL}/verify_api/workflow_management_api/get_workflow_services/${this.workflow_id}`;

      return new Promise((resolve, reject) => {
        $.ajax({
          url: GET_CHECKED_SERVICE_STATUS_API,
          method: "GET",
          contentType: "application/json",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            if (response.status === "success") {
              const serviceSelectionMap = {};
              const workflowProjectServicesMap = {};

              response.data.forEach((item) => {
                serviceSelectionMap[item.project_service_id] = item.is_selected;
                workflowProjectServicesMap[item.project_service_id] =
                  item.workflow_project_service_id;
              });

              this.workflow_project_services = workflowProjectServicesMap;

              this.services.forEach((service) => {
                if (serviceSelectionMap[service.id] !== undefined) {
                  service.is_checked = serviceSelectionMap[service.id];
                  if (service.is_checked) {
                    this.checked_services.add(service.id);

                    if (this.SAFPS_SERVICES.includes(service.service_name)) {
                      this.get_safps_status(service.id);
                    }
                    if (
                      this.DECISION_ENGINE_SERVICES.includes(
                        service.service_name,
                      )
                    ) {
                      this.get_decision_engine_status(service.id);
                    }
                  }
                }
              });
            }
            resolve(response);
          },
          error: (error) => {
            let error_message = "Error Getting Checked Service Status";
            if (error.responseJSON) {
              const ERROR_RESPONSE = error.responseJSON;
              if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
                error_message = ERROR_RESPONSE.error;
              }
            }
            this.showError("Error", error_message);
            reject(error);
          },
        });
      });
    },

    async handle_safps_check(project_service_id, allow_safps) {
      const service = this.services.find((s) => s.id === project_service_id);

      if (!service || !service.is_checked) {
        this.showError(
          "Please select the service first before enabling SAFPS Check.",
        );
        return;
      }

      const workflow_project_service_id =
        this.workflow_project_services[project_service_id];

      if (!workflow_project_service_id) {
        this.showError("Workflow project service not found.");
        return;
      }

      if (allow_safps) {
        try {
          const costInfo = await this.get_safps_cost_info(
            workflow_project_service_id,
          );

          // Check if we have the expected response structure
          if (costInfo && costInfo.base_cost !== undefined) {
            const message = `
              <div class="text-start">
                <p>Enabling SAFPS Check will add an additional fee:</p>
                <ul class="list-unstyled">
                  <li><strong>Base Cost:</strong> R${costInfo.base_cost}</li>
                  <li><strong>SAFPS Fee:</strong> R${costInfo.safps_cost}</li>
                  <li class="border-top pt-2"><strong>Total Cost:</strong> R${costInfo.total_cost_with_safps}</li>
                </ul>
              </div>
            `;

            const result = await Swal.fire({
              title: "Additional SAFPS Fee",
              html: message,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Continue",
              cancelButtonText: "Cancel",
              reverseButtons: true,
            });

            if (result.isConfirmed) {
              await this.safps_check(workflow_project_service_id, allow_safps);
            } else {
              this.$nextTick(() => {
                this.safps_checks[project_service_id] = false;
              });
            }
          } else {
            throw new Error("Invalid response structure");
          }
        } catch (error) {
          console.error("Error getting SAFPS cost info");
          this.showError("Failed to retrieve cost information");
          this.$nextTick(() => {
            this.safps_checks[project_service_id] = false;
          });
        }
      } else {
        await this.safps_check(workflow_project_service_id, allow_safps);
      }
    },

    format_currency(amount) {
      return `R${parseFloat(amount).toFixed(2)}`;
    },

    async get_safps_cost_info(workflow_project_service_id) {
      const TOKEN = localStorage.getItem("token");
      const GET_COST_INFO_API = `${API_BASE_URL}/verify_api/workflow_management_api/safps_cost_info/${workflow_project_service_id}/`;

      return new Promise((resolve, reject) => {
        $.ajax({
          url: GET_COST_INFO_API,
          method: "GET",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            resolve(response);
          },
          error: (error) => {
            reject(error);
          },
        });
      });
    },

    async safps_check(workflow_project_service_id, allow_safps) {
      try {
        const response = await this.safps_check_api({
          workflow_project_service_id: workflow_project_service_id,
          allow_safps: allow_safps,
        });

        if (response.success) {
          if (allow_safps && response.cost_info) {
            this.showSuccess(
              `${response.message}\nNew total cost: ${this.format_currency(
                response.cost_info.total_cost,
              )}`,
            );
          } else {
            this.showSuccess(response.message);
          }

          const project_service_id = Object.keys(
            this.workflow_project_services,
          ).find(
            (key) =>
              this.workflow_project_services[key] ===
              workflow_project_service_id,
          );
          if (project_service_id) {
            this.safps_checks[project_service_id] = allow_safps;
            if (response.cost_info) {
              this.rsa_service_cost = response.cost_info;
            }
          }
        }
      } catch (error) {
        let error_message = "Failed to update SAFPS check status";
        if (error.responseJSON && error.responseJSON.error) {
          error_message = error.responseJSON.error;
        }

        this.showError(error_message);
      }
    },

    async handle_service_check(service_id, isChecked) {
      const TOKEN = localStorage.getItem("token");
      const BASE_URL = API_BASE_URL;

      const ENDPOINTS = {
        CHECK_STATUS: `${BASE_URL}/verify_api/workflow_management_api/get_workflow_status/${this.workflow_id}`,
        SAVE_SERVICES: `${BASE_URL}/verify_api/workflow_management_api/select_workflow_services/${this.workflow_id}`,
        UPDATE_STATUS: `${BASE_URL}/verify_api/workflow_management_api/edit_workflow_api/`,
      };

      let showSuccessMessage = false;

      // Check if service is "Entity Data Capture" and is being checked
      const service = this.services.find((s) => s.id === service_id);
      if (
        service &&
        service.service_name === "Entity Data Capture" &&
        isChecked
      ) {
        const entityTypeResult = await Swal.fire({
          title:
            '<strong style="color: #212529;">Configure Entity Data Capture</strong>',
          html: `
            <style>
              .entity-type-container {
                text-align: left;
                padding: 24px 16px;
              }
              .entity-type-card {
                border: 2px solid #e0e4e8;
                border-radius: 12px;
                padding: 20px 24px;
                margin-bottom: 16px;
                cursor: pointer;
                transition: all 0.25s ease;
                background: #fafbfc;
                position: relative;
                overflow: hidden;
              }
              .entity-type-card::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 4px;
                background: transparent;
                transition: all 0.25s ease;
              }
              .entity-type-card:hover {
                border-color: var(--primary-color);
                background: #ffffff;
                transform: translateY(-2px);
                box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
              }
              .entity-type-card:hover::before {
                background: var(--primary-color);
              }
              .entity-type-card.selected {
                border-color: var(--primary-color);
                background: #f8fdf9;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
              }
              .entity-type-card.selected::before {
                background: var(--primary-color);
              }
              .entity-type-card.error {
                border-color: #dc3545 !important;
                animation: shake 0.4s ease;
              }
              @keyframes shake {
                0%, 100% { transform: translateX(0); }
                25% { transform: translateX(-4px); }
                75% { transform: translateX(4px); }
              }
              .entity-type-card input[type="radio"] {
                margin-right: 14px;
                width: 20px;
                height: 20px;
                cursor: pointer;
                accent-color: var(--primary-color);
              }
              .entity-type-card label {
                cursor: pointer;
                margin-bottom: 6px;
                font-size: 16px;
                font-weight: 600;
                color: #212529;
                display: flex;
                align-items: center;
                width: 100%;
              }
              .entity-type-card .description {
                color: #6c757d;
                font-size: 13px;
                margin-left: 34px;
                margin-top: 2px;
                line-height: 1.5;
              }
              .fields-preview {
                margin-top: 20px;
                padding: 20px;
                background: #ffffff;
                border-radius: 12px;
                border: 2px solid #e0e4e8;
                display: none;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                transition: border-color 0.25s ease;
              }
              .fields-preview.show {
                display: block;
                animation: fadeIn 0.3s ease;
              }
              .fields-preview.error {
                border-color: #dc3545 !important;
                animation: shake 0.4s ease;
              }
              @keyframes fadeIn {
                from { 
                  opacity: 0; 
                  transform: translateY(-8px); 
                }
                to { 
                  opacity: 1; 
                  transform: translateY(0); 
                }
              }
              .fields-preview h4 {
                color: var(--primary-color);
                font-size: 15px;
                margin-bottom: 14px;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 8px;
              }
              .field-list {
                list-style: none;
                padding: 0;
                margin: 0;
              }
              .field-list li {
                padding: 12px 14px;
                margin-bottom: 8px;
                background: #fafbfc;
                border-radius: 8px;
                border-left: 3px solid var(--primary-color);
                font-size: 14px;
                color: #495057;
                display: flex;
                align-items: center;
                transition: all 0.2s ease;
                cursor: pointer;
              }
              .field-list li:last-child {
                margin-bottom: 0;
              }
              .field-list li:hover {
                background: #f0f9f2;
                transform: translateX(4px);
              }
              .field-list li input[type="checkbox"] {
                margin-right: 12px;
                width: 18px;
                height: 18px;
                cursor: pointer;
                accent-color: var(--primary-color);
                flex-shrink: 0;
              }
              .field-list li label {
                cursor: pointer;
                margin: 0;
                flex-grow: 1;
                color: #495057;
                font-weight: 400;
              }
              .field-list li.checked {
                background: #f0f9f2;
              }
              .instruction-text {
                color: #5a6268;
                font-size: 14px;
                margin-top: 90px;
                margin-bottom: 32px;
                padding-bottom: 20px;
                text-align: center;
                line-height: 1.5;
                border-bottom: 1px solid #e9ecef;
              }
              .swal2-popup.entity-capture-modal .swal2-validation-message {
                display: none !important;
              }
              .swal2-popup.entity-capture-modal .swal2-actions {
                margin-top: 16px !important;
                gap: 12px;
              }
              .swal2-popup.entity-capture-modal .swal2-confirm {
                background-color: var(--primary-color) !important;
                border: none !important;
                border-radius: 8px !important;
                font-weight: 600 !important;
                padding: 12px 24px !important;
                font-size: 14px !important;
                transition: all 0.2s ease !important;
              }
              .swal2-popup.entity-capture-modal .swal2-confirm:hover {
                filter: brightness(0.9) !important;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
              }
              .swal2-popup.entity-capture-modal .swal2-cancel {
                background-color: #6c757d !important;
                border: none !important;
                border-radius: 8px !important;
                font-weight: 600 !important;
                padding: 12px 24px !important;
                font-size: 14px !important;
                transition: all 0.2s ease !important;
              }
              .swal2-popup.entity-capture-modal .swal2-cancel:hover {
                background-color: #5a6268 !important;
                box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3) !important;
              }
            </style>
            <div class="entity-type-container">
              
              <div class="entity-type-card" onclick="document.getElementById('companyType').click()">
                  <label for="companyType">
                    <input type="radio" name="entityType" id="companyType" value="company">
                    <span>Company / Business Entity</span>
                  </label>
                  <div class="description">Capture company registration and business information</div>
                </div>

              <div class="entity-type-card" onclick="document.getElementById('individualType').click()">
                <label for="individualType">
                  <input type="radio" name="entityType" id="individualType" value="individual">
                  <span>Individual / Person</span>
                </label>
                <div class="description">Capture personal identification and contact details</div>
              </div>

              <div class="fields-preview" id="companyFields">
                <h4>Company Data Fields</h4>
                <ul class="field-list">
                  <li onclick="this.querySelector('input[type=checkbox]').click(); event.stopPropagation();">
                    <input type="checkbox" id="companyReg" checked onclick="event.stopPropagation(); this.parentElement.classList.toggle('checked', this.checked);">
                    <label for="companyReg" onclick="event.stopPropagation();">Company Registration Number</label>
                  </li>
                  <li onclick="this.querySelector('input[type=checkbox]').click(); event.stopPropagation();">
                    <input type="checkbox" id="companyName" checked onclick="event.stopPropagation(); this.parentElement.classList.toggle('checked', this.checked);">
                    <label for="companyName" onclick="event.stopPropagation();">Company Name</label>
                  </li>
                </ul>
              </div>

              <div class="fields-preview" id="individualFields">
                <h4>Individual Data Fields</h4>
                <ul class="field-list">
                  <li onclick="this.querySelector('input[type=checkbox]').click(); event.stopPropagation();">
                    <input type="checkbox" id="firstName" checked onclick="event.stopPropagation(); this.parentElement.classList.toggle('checked', this.checked);">
                    <label for="firstName" onclick="event.stopPropagation();">First Name</label>
                  </li>
                  <li onclick="this.querySelector('input[type=checkbox]').click(); event.stopPropagation();">
                    <input type="checkbox" id="lastName" checked onclick="event.stopPropagation(); this.parentElement.classList.toggle('checked', this.checked);">
                    <label for="lastName" onclick="event.stopPropagation();">Last Name</label>
                  </li>
                  <li onclick="this.querySelector('input[type=checkbox]').click(); event.stopPropagation();">
                    <input type="checkbox" id="idNumber" checked onclick="event.stopPropagation(); this.parentElement.classList.toggle('checked', this.checked);">
                    <label for="idNumber" onclick="event.stopPropagation();">ID Number</label>
                  </li>
                  <li onclick="this.querySelector('input[type=checkbox]').click(); event.stopPropagation();">
                    <input type="checkbox" id="birthDate" checked onclick="event.stopPropagation(); this.parentElement.classList.toggle('checked', this.checked);">
                    <label for="birthDate" onclick="event.stopPropagation();">Birth Date</label>
                  </li>
                  <li onclick="this.querySelector('input[type=checkbox]').click(); event.stopPropagation();">
                    <input type="checkbox" id="countryOfBirth" checked onclick="event.stopPropagation(); this.parentElement.classList.toggle('checked', this.checked);">
                    <label for="countryOfBirth" onclick="event.stopPropagation();">Country of Birth</label>
                  </li>
                </ul>
              </div>
            </div>
          `,
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Confirm Selection",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#248232",
          cancelButtonColor: "#6c757d",
          reverseButtons: true,
          customClass: {
            popup: "entity-capture-modal",
            confirmButton: "swal2-confirm",
            cancelButton: "swal2-cancel",
          },
          didOpen: () => {
            const companyRadio = document.getElementById("companyType");
            const individualRadio = document.getElementById("individualType");
            const companyCard = companyRadio.closest(".entity-type-card");
            const individualCard = individualRadio.closest(".entity-type-card");
            const companyFields = document.getElementById("companyFields");
            const individualFields =
              document.getElementById("individualFields");

            function updateSelection() {
              // Remove all selected states
              companyCard.classList.remove("selected");
              individualCard.classList.remove("selected");
              companyFields.classList.remove("show");
              individualFields.classList.remove("show");

              // Add selected state to checked radio
              if (companyRadio.checked) {
                companyCard.classList.add("selected");
                companyFields.classList.add("show");
              } else if (individualRadio.checked) {
                individualCard.classList.add("selected");
                individualFields.classList.add("show");
              }
            }

            companyRadio.addEventListener("change", updateSelection);
            individualRadio.addEventListener("change", updateSelection);

            // Initialize checked state styling
            document
              .querySelectorAll('.field-list input[type="checkbox"]')
              .forEach((checkbox) => {
                if (checkbox.checked) {
                  checkbox.parentElement.classList.add("checked");
                }
              });
          },
          preConfirm: () => {
            const selectedType = document.querySelector(
              'input[name="entityType"]:checked',
            );
            if (!selectedType) {
              // Add error class to both entity cards
              document.querySelectorAll(".entity-type-card").forEach((card) => {
                card.classList.add("error");
                setTimeout(() => card.classList.remove("error"), 400);
              });
              return false;
            }

            // Collect selected fields based on entity type
            const selectedFields = [];
            const fieldsContainer =
              selectedType.value === "company"
                ? document.getElementById("companyFields")
                : document.getElementById("individualFields");

            fieldsContainer
              .querySelectorAll('input[type="checkbox"]:checked')
              .forEach((checkbox) => {
                selectedFields.push(checkbox.nextElementSibling.textContent);
              });

            if (selectedFields.length === 0) {
              // Add error class to fields preview
              fieldsContainer.classList.add("error");
              setTimeout(() => fieldsContainer.classList.remove("error"), 400);
              return false;
            }

            return {
              entityType: selectedType.value,
              fields: selectedFields,
            };
          },
        });

        if (!entityTypeResult.isConfirmed) {
          // User cancelled, revert checkbox
          service.is_checked = false;
          this.$nextTick();
          return;
        }

        const entityType = entityTypeResult.value.entityType;
        const selectedFields = entityTypeResult.value.fields;

        // Store the entity type and selected fields for future use
        service.entity_type = entityType;
        service.selected_fields = selectedFields;
      }

      try {
        const statusResponse = await $.ajax({
          url: ENDPOINTS.CHECK_STATUS,
          method: "GET",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
        });

        if (statusResponse.status === "approved") {
          const result = await Swal.fire({
            title: "Warning",
            text: "This workflow is currently approved. Making changes will set it back to incomplete status. Do you want to continue?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, continue",
            cancelButtonText: "No, cancel",
            reverseButtons: true,
          });

          if (!result.isConfirmed) {
            const service = this.services.find(
              (service) => service.id === service_id,
            );
            if (service) {
              service.is_checked = !isChecked;
              this.$nextTick();
            }
            return;
          }

          showSuccessMessage = true;

          try {
            await $.ajax({
              url: ENDPOINTS.UPDATE_STATUS,
              method: "POST",
              contentType: "application/json",
              data: JSON.stringify({
                workflow_id: this.workflow_id,
                status: "incomplete",
              }),
              headers: {
                Authorization: `Token ${TOKEN}`,
              },
            });
          } catch (error) {
            const service = this.services.find(
              (service) => service.id === service_id,
            );
            if (service) {
              service.is_checked = !isChecked;
            }
            this.showError("Failed to update workflow status");
            return;
          }
        } else if (statusResponse.status === "pending") {
          const result = await Swal.fire({
            title: "Warning",
            text: "This workflow is currently pending approval. Making changes will set it back to incomplete status. Do you want to continue?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, continue",
            cancelButtonText: "No, cancel",
            reverseButtons: true,
          });

          if (!result.isConfirmed) {
            const service = this.services.find(
              (service) => service.id === service_id,
            );
            if (service) {
              service.is_checked = !isChecked;
              this.$nextTick();
            }
            return;
          }

          showSuccessMessage = true;

          try {
            await $.ajax({
              url: ENDPOINTS.UPDATE_STATUS,
              method: "POST",
              contentType: "application/json",
              data: JSON.stringify({
                workflow_id: this.workflow_id,
                status: "incomplete",
              }),
              headers: {
                Authorization: `Token ${TOKEN}`,
              },
            });
          } catch (error) {
            const service = this.services.find(
              (service) => service.id === service_id,
            );
            if (service) {
              service.is_checked = !isChecked;
            }
            this.showError("Failed to update workflow status");
            return;
          }
        }

        if (!isChecked) {
          const service = this.services.find(
            (service) => service.id === service_id,
          );
          if (service && service.service_name === "RSA ID Verification") {
            const wasSafpsEnabled = this.safps_checks[service_id];

            if (wasSafpsEnabled) {
              const workflow_project_service_id =
                this.workflow_project_services[service_id];
              if (workflow_project_service_id) {
                try {
                  await this.safps_check_api({
                    workflow_project_service_id: workflow_project_service_id,
                    allow_safps: false,
                  });
                } catch (error) {
                  console.error("Error disabling SAFPS check");
                }
              }
            }

            this.safps_checks[service_id] = false;
          }

          // Disable Decision Engine when unchecking Credit Report Namibia
          if (
            service &&
            this.DECISION_ENGINE_SERVICES.includes(service.service_name)
          ) {
            const wasDecisionEngineEnabled =
              this.add_decision_engine[service_id];

            if (wasDecisionEngineEnabled) {
              const workflow_project_service_id =
                this.workflow_project_services[service_id];
              if (workflow_project_service_id) {
                try {
                  await this.decision_engine_check_api({
                    workflow_project_service_id: workflow_project_service_id,
                    allow_decision_engine: false,
                  });
                } catch (error) {
                  console.error("Error disabling Decision Engine");
                }
              }
            }

            this.add_decision_engine[service_id] = false;
          }
        }

        const response = await $.ajax({
          url: ENDPOINTS.SAVE_SERVICES,
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({
            workflow_id: this.workflow_id,
            project_service_id: service_id,
            is_selected: isChecked,
          }),
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
        });

        if (response.status === "success") {
          const service = this.services.find(
            (service) => service.id === service_id,
          );
          if (service) {
            service.is_checked = isChecked;

            if (isChecked) {
              this.checked_services.add(service_id);

              await this.update_service_status();

              // Save entity data capture configuration after service is added to workflow
              if (
                service.service_name === "Entity Data Capture" &&
                service.entity_type &&
                service.selected_fields
              ) {
                try {
                  await this.save_entity_data_capture_config(
                    service_id,
                    service.entity_type,
                    service.selected_fields,
                  );
                  this.showSuccess(
                    "Entity Data Capture configuration saved successfully",
                  );
                } catch (error) {
                  console.error(
                    "Error saving entity data capture config",
                  );
                  this.showError(
                    "Failed to save entity data capture configuration",
                  );
                }
              }

              if (this.SAFPS_SERVICES.includes(service.service_name)) {
                setTimeout(() => {
                  this.get_safps_status(service_id);
                }, 200);
              }
              if (
                this.DECISION_ENGINE_SERVICES.includes(service.service_name)
              ) {
                setTimeout(() => {
                  this.get_decision_engine_status(service_id);
                }, 200);
              }
            } else {
              this.checked_services.delete(service_id);
              delete this.workflow_project_services[service_id];
            }
          }

          if (showSuccessMessage) {
            this.showSuccess(response.message);
          }
        }
      } catch (error) {
        let error_message = "Error Saving Service";
        if (error.responseJSON) {
          const ERROR_RESPONSE = error.responseJSON;
          if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
            error_message = ERROR_RESPONSE.error;
          }
        }
        this.showError(error_message);

        const service = this.services.find(
          (service) => service.id === service_id,
        );
        if (service) {
          service.is_checked = !isChecked;
        }
      }
    },

    check_if_no_service_selected() {
      if (this.checked_services.size === 0) {
        this.showError(
          "You must select at least one service before proceeding.",
        );
        return false;
      }
      return true;
    },

    safps_check_api(data) {
      const TOKEN = localStorage.getItem("token");
      const SAFPS_CHECK_API = `${API_BASE_URL}/verify_api/workflow_management_api/safps_check/`;

      return new Promise((resolve, reject) => {
        $.ajax({
          url: SAFPS_CHECK_API,
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify(data),
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            resolve(response);
          },
          error: (error) => {
            reject(error);
          },
        });
      });
    },

    get_safps_status(project_service_id) {
      const workflow_project_service_id =
        this.workflow_project_services[project_service_id];
      if (!workflow_project_service_id) return;

      const TOKEN = localStorage.getItem("token");
      const GET_SAFPS_STATUS_API = `${API_BASE_URL}/verify_api/workflow_management_api/safps_check/${workflow_project_service_id}/`;

      $.ajax({
        url: GET_SAFPS_STATUS_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          this.safps_checks[project_service_id] = response.allow_safps;

          const service = this.services.find(
            (s) => s.id === project_service_id,
          );
          if (service && service.service_name === "RSA ID Verification") {
            service.safps_enabled = response.allow_safps;
          }
        },
        error: () => {
          this.safps_checks[project_service_id] = false;
        },
      });
    },

    get_decision_engine_status(project_service_id) {
      const workflow_project_service_id =
        this.workflow_project_services[project_service_id];
      if (!workflow_project_service_id) return;

      const TOKEN = localStorage.getItem("token");
      const GET_DECISION_ENGINE_STATUS_API = `${API_BASE_URL}/verify_api/workflow_management_api/decision_engine_check/${workflow_project_service_id}/`;

      $.ajax({
        url: GET_DECISION_ENGINE_STATUS_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          this.add_decision_engine = { ...this.add_decision_engine, [project_service_id]: response.allow_decision_engine };

          const service = this.services.find(
            (s) => s.id === project_service_id,
          );
          if (
            service &&
            this.DECISION_ENGINE_SERVICES.includes(service.service_name)
          ) {
            service.decision_engine_enabled = response.allow_decision_engine;
          }
        },
        error: () => {
          this.add_decision_engine = { ...this.add_decision_engine, [project_service_id]: false };
        },
      });
    },

    async handle_decision_engine_check(
      project_service_id,
      allow_decision_engine,
    ) {
      const service = this.services.find((s) => s.id === project_service_id);

      if (!service || !service.is_checked) {
        this.showError(
          "Please select the service first before enabling Decision Engine.",
        );
        return;
      }

      const workflow_project_service_id =
        this.workflow_project_services[project_service_id];

      if (!workflow_project_service_id) {
        this.showError("Workflow project service not found.");
        return;
      }

      if (allow_decision_engine) {
        const result = await Swal.fire({
          title: "Enable Decision Engine",
          html: `
        <div class="text-start">
          <p>Enabling the Instant Decision Engine will provide automated credit decision recommendations.</p>
          <p class="text-muted small">Additional charges may apply.</p>
        </div>
      `,
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Enable",
          cancelButtonText: "Cancel",
          reverseButtons: true,
        });

        if (result.isConfirmed) {
          await this.decision_engine_check(
            workflow_project_service_id,
            allow_decision_engine,
            project_service_id,
          );
        } else {
          // User cancelled - revert the checkbox state
          this.add_decision_engine = { ...this.add_decision_engine, [project_service_id]: false };
        }
      } else {
        await this.decision_engine_check(
          workflow_project_service_id,
          allow_decision_engine,
          project_service_id,
        );
      }
    },

    async decision_engine_check(
      workflow_project_service_id,
      allow_decision_engine,
      project_service_id,
    ) {
      try {
        const response = await this.decision_engine_check_api({
          workflow_project_service_id: workflow_project_service_id,
          allow_decision_engine: allow_decision_engine,
        });

        if (response.success) {
          this.showSuccess(response.message);
          this.add_decision_engine = { ...this.add_decision_engine, [project_service_id]: allow_decision_engine };

          const service = this.services.find(
            (s) => s.id === project_service_id,
          );
          if (service) {
            service.decision_engine_enabled = allow_decision_engine;
          }
        }
      } catch (error) {
        let error_message = "Failed to update Decision Engine status";
        if (error.responseJSON && error.responseJSON.error) {
          error_message = error.responseJSON.error;
        }

        this.showError(error_message);
        this.add_decision_engine = { ...this.add_decision_engine, [project_service_id]: !allow_decision_engine };
      }
    },

    decision_engine_check_api(data) {
      const TOKEN = localStorage.getItem("token");
      const DECISION_ENGINE_CHECK_API = `${API_BASE_URL}/verify_api/workflow_management_api/decision_engine_check/`;

      return new Promise((resolve, reject) => {
        $.ajax({
          url: DECISION_ENGINE_CHECK_API,
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify(data),
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            resolve(response);
          },
          error: (error) => {
            reject(error);
          },
        });
      });
    },

    navigate_to_client_service() {
      this.$router.push({ name: "client_services" });
    },

    route_to_arrange_workflow() {
      if (this.check_if_no_service_selected()) {
        this.$router.push({ name: "arrange_workflow" });
      }
    },

    route_to_rules(service_id) {
      this.$router.push({
        name: "service_rules",
        params: { service_id: service_id },
      });
    },

    async save_entity_data_capture_config(
      service_id,
      entity_type,
      selected_fields,
    ) {
      const TOKEN = localStorage.getItem("token");
      const SAVE_CONFIG_API = `${API_BASE_URL}/verify_api/service_management_api/save_entity_data_capture_config/`;

      return new Promise((resolve, reject) => {
        $.ajax({
          url: SAVE_CONFIG_API,
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({
            workflow_id: this.workflow_id,
            project_service_id: service_id,
            entity_type: entity_type,
            selected_fields: selected_fields,
          }),
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            if (response.status === "success") {
              resolve(response);
            } else {
              reject(
                new Error(response.message || "Failed to save configuration"),
              );
            }
          },
          error: (error) => {
            let error_message =
              "Error saving entity data capture configuration";
            if (error.responseJSON && error.responseJSON.message) {
              error_message = error.responseJSON.message;
            }
            reject(new Error(error_message));
          },
        });
      });
    },

    async show_customize_register_modal() {
      const TOKEN = localStorage.getItem("token");
      const GET_REGISTER_FORMS_API = `${API_BASE_URL}/verify_api/form_management_api/get_register_forms/`;

      try {
        const response = await new Promise((resolve, reject) => {
          $.ajax({
            url: GET_REGISTER_FORMS_API,
            method: "GET",
            contentType: "application/json",
            headers: {
              Authorization: `Token ${TOKEN}`,
            },
            success: resolve,
            error: reject,
          });
        });

        if (response.status === "success") {
          this.register_forms = response.data;
          // Fetch workflows and assigned workflows in parallel
          await Promise.all([
            this.fetch_workflows(),
            this.fetch_assigned_workflows_for_forms(),
          ]);
          this.display_register_forms_modal();
        }
      } catch (error) {
        let error_message = "Error fetching register forms";
        if (error.responseJSON && error.responseJSON.message) {
          error_message = error.responseJSON.message;
        }
        this.showError("Error", error_message);
      }
    },

    display_register_forms_modal() {
      let formsHtml = "";

      if (this.register_forms.length === 0) {
        formsHtml = `
          <div class="text-center py-4">
            <i class="fas fa-clipboard-list fa-2x text-muted mb-2 opacity-50"></i>
            <p class="text-muted mb-0 small">No register forms available</p>
          </div>
        `;
      } else {
        this.register_forms.forEach((form) => {
          const assignedWorkflows = this.assigned_workflows_map[form.id] || [];
          // Use == instead of === to handle type coercion (string vs number)
          const isAssignedToCurrentWorkflow = assignedWorkflows.some(
            (w) => w.workflow_id == this.workflow_id,
          );
          const questionCount = form.questions.length;

          const questionsHtml = form.questions
            .map(
              (q, index) =>
                `<div class="d-flex align-items-start mb-2">
              <span class="badge bg-secondary me-2 small" style="min-width: 22px; font-size: 11px;">${
                index + 1
              }</span>
              <span class="small text-dark">${q.question}</span>
            </div>`,
            )
            .join("");

          const questionsSection =
            questionCount > 0
              ? `<div class="ps-1">${questionsHtml}</div>`
              : `<p class="text-muted small mb-0">No questions assigned</p>`;

          formsHtml += `
            <div class="border rounded mb-2 bg-white">
              <div class="p-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1 me-3">
                    <div class="fw-semibold text-dark mb-1" style="font-size: 14px;">
                      <i class="fas fa-file-alt text-primary me-1" style="font-size: 12px;"></i>
                      ${form.service_name}
                      ${
                        isAssignedToCurrentWorkflow
                          ? '<span class="badge bg-success ms-2" style="font-size: 10px;">Active</span>'
                          : ""
                      }
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                      <span class="badge ${
                        questionCount > 0 ? "bg-info" : "bg-light text-muted"
                      }" style="font-size: 11px;">
                        ${questionCount} question${
            questionCount !== 1 ? "s" : ""
          }
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <button type="button" class="btn btn-outline-primary btn-sm edit-form-btn px-3" data-service-id="${
                      form.id
                    }" style="font-size: 12px; padding: 4px 12px;">
                      <i class="fas fa-edit me-1"></i>Edit
                    </button>
                    <div class="form-check form-switch mb-0">
                      <input class="form-check-input assign-toggle" 
                             type="checkbox" 
                             id="toggle_${form.id}" 
                             data-service-id="${form.id}" 
                             data-service-name="${form.service_name}" 
                             data-question-count="${questionCount}"
                             ${isAssignedToCurrentWorkflow ? "checked" : ""}
                             style="cursor: pointer; width: 40px; height: 20px;">
                      <label class="form-check-label fw-semibold" for="toggle_${
                        form.id
                      }" style="cursor: pointer; font-size: 12px; margin-left: 8px; color: ${
            isAssignedToCurrentWorkflow ? "#28a745" : "#6c757d"
          };">
                        ${isAssignedToCurrentWorkflow ? "Active" : "Inactive"}
                      </label>
                    </div>
                  </div>
                </div>
                <details class="mt-2">
                  <summary class="text-muted small" style="cursor: pointer; font-size: 12px;">
                    <i class="fas fa-chevron-right me-1" style="font-size: 10px;"></i>View questions
                  </summary>
                  <div class="mt-2 pt-2 border-top">
                    ${questionsSection}
                  </div>
                </details>
              </div>
            </div>
          `;
        });
      }

      Swal.fire({
        title: "Customize Register Page",
        html: `
          <style>
            .swal2-container details[open] summary i.fa-chevron-right { transform: rotate(90deg); }
          </style>
          <div class="text-start">
            <div class="d-flex justify-content-end mb-3">
              <button type="button" id="createNewRegisterBtn" class="btn btn-success btn-sm" style="font-size: 12px;">
                <i class="fas fa-plus me-1"></i>Create New
              </button>
            </div>
            <div style="max-height: 400px; overflow-y: auto;">
              ${formsHtml}
            </div>
          </div>
        `,
        width: "600px",
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: "rounded-3",
          title: "text-start fs-6 fw-bold pb-2 border-bottom",
          htmlContainer: "text-start pt-3",
        },
        didOpen: () => {
          // Attach event listener for create button
          const createBtn = document.getElementById("createNewRegisterBtn");
          if (createBtn) {
            createBtn.addEventListener("click", () => {
              Swal.close();
              this.create_register_service();
            });
          }

          // Attach event listeners for edit buttons
          const editButtons = document.querySelectorAll(".edit-form-btn");
          editButtons.forEach((btn) => {
            btn.addEventListener("click", (e) => {
              const serviceId = e.currentTarget.getAttribute("data-service-id");
              Swal.close();
              this.edit_register_form(serviceId);
            });
          });

          // Attach event listeners for toggle switches
          const toggles = document.querySelectorAll(".assign-toggle");
          toggles.forEach((toggle) => {
            toggle.addEventListener("change", async (e) => {
              const serviceId = e.currentTarget.getAttribute("data-service-id");
              const serviceName =
                e.currentTarget.getAttribute("data-service-name");
              const questionCount =
                parseInt(e.currentTarget.getAttribute("data-question-count")) ||
                0;
              const isChecked = e.currentTarget.checked;

              // Close the modal first
              Swal.close();

              // Perform the action
              if (isChecked) {
                await this.assign_to_current_workflow(
                  serviceId,
                  serviceName,
                  questionCount,
                );
              } else {
                await this.unassign_from_current_workflow(
                  serviceId,
                  serviceName,
                );
              }
            });
          });
        },
      });
    },

    async create_register_service() {
      const TOKEN = localStorage.getItem("token");
      const CREATE_REGISTER_SERVICE_API = `${API_BASE_URL}/verify_api/form_management_api/create_register_service/`;

      try {
        const response = await new Promise((resolve, reject) => {
          $.ajax({
            url: CREATE_REGISTER_SERVICE_API,
            method: "POST",
            contentType: "application/json",
            headers: {
              Authorization: `Token ${TOKEN}`,
            },
            data: JSON.stringify({
              project_id: this.project_id,
            }),
            success: resolve,
            error: reject,
          });
        });

        if (response.status === "success") {
          this.showSuccess("Success", response.message);

          // Navigate to question selection page with the new service ID
          this.$router.push({
            name: "register_question_selection",
            params: { service_id: response.data.service_id },
          });
        }
      } catch (error) {
        let error_message = "Error creating register service";
        if (error.responseJSON && error.responseJSON.message) {
          error_message = error.responseJSON.message;
        }
        this.showError("Error", error_message);
      }
    },

    edit_register_form(service_id) {
      // Navigate to question selection page for editing
      this.$router.push({
        name: "register_question_selection",
        params: { service_id: service_id },
      });
    },

    async fetch_workflows() {
      const TOKEN = localStorage.getItem("token");
      const GET_PROJECTS_API = `${API_BASE_URL}/verify_api/workflow_management_api/get_client_projects/`;

      try {
        const response = await new Promise((resolve, reject) => {
          $.ajax({
            url: GET_PROJECTS_API,
            method: "GET",
            headers: {
              Authorization: `Token ${TOKEN}`,
            },
            success: resolve,
            error: reject,
          });
        });

        // Extract workflows from projects
        const workflows = [];
        if (response.projects && Array.isArray(response.projects)) {
          response.projects.forEach((project) => {
            if (project.workflows && Array.isArray(project.workflows)) {
              project.workflows.forEach((workflow) => {
                workflows.push({
                  id: workflow.id,
                  workflow_name: workflow.workflow_name,
                  project_name: project.project_name,
                  project_id: project.id,
                });
              });
            }
          });
        }

        this.workflows = workflows;
      } catch (error) {
        console.error("Error fetching workflows");
        this.workflows = [];
      }
    },

    async fetch_assigned_workflows_for_forms() {
      const TOKEN = localStorage.getItem("token");
      this.assigned_workflows_map = {};

      const promises = this.register_forms.map(async (form) => {
        const GET_ASSIGNED_API = `${API_BASE_URL}/verify_api/form_management_api/get_register_assigned_workflows/${form.id}/`;

        try {
          const response = await new Promise((resolve, reject) => {
            $.ajax({
              url: GET_ASSIGNED_API,
              method: "GET",
              headers: {
                Authorization: `Token ${TOKEN}`,
              },
              success: resolve,
              error: reject,
            });
          });

          this.assigned_workflows_map[form.id] = response.data || [];
        } catch (error) {
          console.error(
            `Error fetching assigned workflows for form`,
          );
          this.assigned_workflows_map[form.id] = [];
        }
      });

      await Promise.all(promises);
    },

    is_workflow_assigned(service_id, workflow_id) {
      const assigned = this.assigned_workflows_map[service_id] || [];
      // Use == instead of === to handle type coercion (string vs number)
      return assigned.some((w) => w.workflow_id == workflow_id);
    },

    async assign_to_current_workflow(
      service_id,
      service_name,
      question_count = 0,
    ) {
      // Check if form has questions before allowing assignment
      if (question_count === 0) {
        await Swal.fire({
          title: "Cannot Assign",
          text: "This register form has no questions. Please add questions before assigning it to a workflow.",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });
        // Don't reopen modal - let user manually open it again
        return;
      }

      // Check if current workflow already has a register form assigned
      const currentWorkflowId = this.workflow_id;

      // Check if this service is already assigned to current workflow
      if (this.is_workflow_assigned(service_id, currentWorkflowId)) {
        this.showError(
          "Error",
          "This register form is already assigned to this workflow",
        );
        return;
      }

      // Check if ANY register form is already assigned to this workflow
      const hasAnyRegisterAssigned = this.register_forms.some((form) => {
        const assignedWorkflows = this.assigned_workflows_map[form.id] || [];
        return assignedWorkflows.some(
          (w) => w.workflow_id == currentWorkflowId,
        );
      });

      if (hasAnyRegisterAssigned) {
        this.showError(
          "Error",
          "This workflow already has a register form assigned. Please unassign it first.",
        );
        return;
      }

      const result = await Swal.fire({
        title: "Assign Register Form",
        text: `Assign "${service_name}" as the register page for this workflow?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Assign",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#28a745",
      });

      if (!result.isConfirmed) {
        this.display_register_forms_modal();
        return;
      }

      const TOKEN = localStorage.getItem("token");
      const ASSIGN_API = `${API_BASE_URL}/verify_api/form_management_api/assign_register_to_workflow/`;

      try {
        const response = await new Promise((resolve, reject) => {
          $.ajax({
            url: ASSIGN_API,
            method: "POST",
            contentType: "application/json",
            headers: {
              Authorization: `Token ${TOKEN}`,
            },
            data: JSON.stringify({
              service_id: service_id,
              workflow_id: currentWorkflowId,
            }),
            success: resolve,
            error: reject,
          });
        });

        if (response.status === "success") {
          this.showSuccess("Success", response.message);
          await this.fetch_assigned_workflows_for_forms();
          // Reopen the customize modal
          this.display_register_forms_modal();
        }
      } catch (error) {
        let error_message = "Failed to assign register form";
        if (error.responseJSON && error.responseJSON.message) {
          error_message = error.responseJSON.message;
        }
        this.showError("Error", error_message);
        this.display_register_forms_modal();
      }
    },

    async unassign_from_current_workflow(service_id, service_name) {
      const currentWorkflowId = this.workflow_id;

      const result = await Swal.fire({
        title: "Unassign Register Form",
        text: `Remove "${service_name}" from this workflow's register page?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#dc3545",
      });

      if (!result.isConfirmed) {
        this.display_register_forms_modal();
        return;
      }

      const TOKEN = localStorage.getItem("token");
      const UNASSIGN_API = `${API_BASE_URL}/verify_api/form_management_api/unassign_register_from_workflow/`;

      try {
        const response = await new Promise((resolve, reject) => {
          $.ajax({
            url: UNASSIGN_API,
            method: "POST",
            contentType: "application/json",
            headers: {
              Authorization: `Token ${TOKEN}`,
            },
            data: JSON.stringify({
              service_id: service_id,
              workflow_id: currentWorkflowId,
            }),
            success: resolve,
            error: reject,
          });
        });

        if (response.status === "success") {
          this.showSuccess("Success", response.message);
          await this.fetch_assigned_workflows_for_forms();
          // Reopen the customize modal
          this.display_register_forms_modal();
        }
      } catch (error) {
        let error_message = "Failed to unassign register form";
        if (error.responseJSON && error.responseJSON.message) {
          error_message = error.responseJSON.message;
        }
        this.showError("Error", error_message);
        this.display_register_forms_modal();
      }
    },

    async assign_to_workflow(
      service_id,
      service_name,
      workflow_id,
      workflow_name,
    ) {
      if (this.is_workflow_assigned(service_id, workflow_id)) {
        this.showError(
          "Error",
          `This register form is already assigned to ${workflow_name}`,
        );
        return;
      }

      const result = await Swal.fire({
        title: "Assign to Workflow",
        text: `Assign "${service_name}" to "${workflow_name}"?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Assign",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#28a745",
      });

      if (!result.isConfirmed) return;

      const TOKEN = localStorage.getItem("token");
      const ASSIGN_API = `${API_BASE_URL}/verify_api/form_management_api/assign_register_to_workflow/`;

      try {
        const response = await new Promise((resolve, reject) => {
          $.ajax({
            url: ASSIGN_API,
            method: "POST",
            contentType: "application/json",
            headers: {
              Authorization: `Token ${TOKEN}`,
            },
            data: JSON.stringify({
              service_id: service_id,
              workflow_id: workflow_id,
            }),
            success: resolve,
            error: reject,
          });
        });

        if (response.status === "success") {
          this.showSuccess("Success", response.message);
          await this.fetch_assigned_workflows_for_forms();
          // Reopen the customize modal
          this.display_register_forms_modal();
        }
      } catch (error) {
        let error_message = "Failed to assign to workflow";
        if (error.responseJSON && error.responseJSON.message) {
          error_message = error.responseJSON.message;
        }
        this.showError("Error", error_message);
      }
    },

    show_workflow_assignment_modal(service_id, service_name) {
      if (this.workflows.length === 0) {
        this.showError("Error", "No workflows available");
        return;
      }

      const workflowsHtml = this.workflows
        .map((workflow) => {
          const isAssigned = this.is_workflow_assigned(service_id, workflow.id);

          return `
          <div class="d-flex justify-content-between align-items-center p-2 border rounded mb-2 ${
            isAssigned ? "bg-light" : "bg-white"
          }">
            <div class="flex-grow-1">
              <div class="fw-semibold small text-dark">
                <i class="fas fa-project-diagram ${
                  isAssigned ? "text-secondary" : "text-primary"
                } me-1" style="font-size: 11px;"></i>
                ${workflow.workflow_name}
              </div>
              <small class="text-muted" style="font-size: 11px;">
                <i class="fas fa-folder me-1"></i>${
                  workflow.project_name || "N/A"
                }
              </small>
            </div>
            ${
              isAssigned
                ? `
              <span class="badge bg-secondary" style="font-size: 11px;">Assigned</span>
            `
                : `
              <button class="btn btn-success btn-sm assign-workflow-btn" data-workflow-id="${workflow.id}" data-workflow-name="${workflow.workflow_name}" style="font-size: 11px;">
                <i class="fas fa-plus me-1"></i>Assign
              </button>
            `
            }
          </div>
        `;
        })
        .join("");

      Swal.fire({
        title: "Assign to Workflow",
        html: `
          <div class="text-start">
            <p class="text-muted small mb-3">Assign <strong>"${service_name}"</strong> to a workflow</p>
            <div style="max-height: 350px; overflow-y: auto;">
              ${workflowsHtml}
            </div>
          </div>
        `,
        width: "500px",
        showConfirmButton: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: '<i class="fas fa-arrow-left me-1"></i>Back',
        customClass: {
          popup: "rounded-3",
          title: "text-start fs-6 fw-bold pb-2 border-bottom",
          htmlContainer: "text-start pt-3",
          cancelButton: "btn btn-light btn-sm border",
        },
        didOpen: () => {
          const assignButtons = document.querySelectorAll(
            ".assign-workflow-btn",
          );
          assignButtons.forEach((btn) => {
            btn.addEventListener("click", (e) => {
              const workflowId = parseInt(
                e.currentTarget.getAttribute("data-workflow-id"),
              );
              const workflowName =
                e.currentTarget.getAttribute("data-workflow-name");
              Swal.close();
              this.assign_to_workflow(
                service_id,
                service_name,
                workflowId,
                workflowName,
              );
            });
          });
        },
        preConfirm: () => {
          return false;
        },
      }).then((result) => {
        if (
          result.isDismissed &&
          result.dismiss === Swal.DismissReason.cancel
        ) {
          // Back button clicked, reopen customize modal
          this.display_register_forms_modal();
        }
      });
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_services_in_project();
  },
};
